<template lang="pug">
section.section.main-content
  .o-container
    .quote-message
      header.headline
        h1.headline__title Usuario Creado
        router-link(class="button button--orange-outlined" :to="{ name: 'Dashboard' }") IR AL DASHBOARD
</template>
<script>
export default {
  name: 'UserCreated',
}
</script>
<style lang="scss" scoped>
.headline{
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>